export default __webpack_public_path__ + "static/media/certificate_python.79112c35.WebP";